import { twMerge } from 'tailwind-merge';
import React, { forwardRef, InputHTMLAttributes } from 'react';
import Icon, { IconKey } from './Icon';

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    iconKey?: IconKey;
    rows?: number;
}

const BaseTextArea = forwardRef<HTMLTextAreaElement, Props>(
    (
        { id, label = null, className = '', iconKey, rows = 3, ...props },
        ref,
    ) => {
        return (
            <div className="flex w-full flex-col gap-y-1.5">
                {label ? (
                    <label
                        htmlFor={id}
                        className="flex text-sm font-bold text-gray-800"
                    >
                        {label}
                    </label>
                ) : null}

                <div className="relative w-full rounded-sm">
                    <textarea
                        id={id}
                        ref={ref}
                        rows={rows}
                        // Only when there is no visible label to point at:
                        // otherwise the label above already names the field,
                        // and a second name would override what is on screen.
                        aria-label={label ? undefined : props.placeholder}
                        className={twMerge(
                            'form-input focus-ring block w-full rounded-md border-0 bg-gray-100 p-3 text-sm/4 text-gray-800 placeholder:text-gray-500 read-only:bg-gray-100 focus:ring-0 disabled:text-gray-400 dark:bg-gray-100 dark:disabled:text-gray-600',
                            className,
                            iconKey ? 'pe-10' : '',
                        )}
                        {...props}
                    />
                    {iconKey ? (
                        <div className="pointer-events-none absolute inset-y-0 end-0 flex items-center pe-3 text-gray-600">
                            <Icon iconKey={iconKey} size="24px" />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    },
);

export default BaseTextArea;
